"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildChildSurveyTimeline;
const taskStore_1 = require("../../taskStore");
const config_1 = require("../child-survey/helpers/config");
const helpers_1 = require("../shared/helpers");
const trials_1 = require("../shared/trials");
const taskSetup_1 = require("../taskSetup");
const stimulus_1 = require("./helpers/stimulus");
function buildChildSurveyTimeline(config, mediaAssets) {
    const preloadTrials = (0, helpers_1.createPreloadTrials)(mediaAssets).default;
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const timeline = [preloadTrials, initialTimeline];
    let corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    const translations = (0, taskStore_1.taskStore)().translations;
    const validationErrorMap = {};
    (0, taskStore_1.taskStore)('totalTrials', corpus.length);
    const layoutConfigMap = {};
    let i = 0;
    for (const c of corpus) {
        const { itemConfig, errorMessages } = (0, config_1.getLayoutConfig)(c, translations, mediaAssets, i);
        layoutConfigMap[c.itemId] = itemConfig;
        if (errorMessages.length) {
            validationErrorMap[c.itemId] = errorMessages.join('; ');
        }
        i += 1;
    }
    if (Object.keys(validationErrorMap).length) {
        console.error('The following errors were found');
        console.table(validationErrorMap);
        throw new Error('Something went wrong. Please look in the console for error details');
    }
    const trialConfig = {
        trialType: 'audio',
        responseAllowed: true,
        promptAboveButtons: true,
        task: config.task,
        layoutConfigMap,
        terminateCat: false,
    };
    const stimulusBlock = {
        timeline: [{ ...trials_1.setupStimulus, stimulus: '' }, (0, stimulus_1.surveyItem)(trialConfig)],
    };
    (0, taskStore_1.taskStore)('totalTestTrials', (0, helpers_1.getRealTrials)(corpus));
    const numOfTrials = (0, taskStore_1.taskStore)().totalTrials;
    for (let i = 0; i < numOfTrials; i++) {
        timeline.push(stimulusBlock);
    }
    (0, taskSetup_1.initializeCat)();
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
